<div class="dialog-size">
  <mat-dialog-content class="mat-content dialog-mat-content text-center">
    <p>
      {{message}}
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-raised-button *ngIf="okButtonVisible" class="btn-bg-color btn-size" (click)="onConfirmClick(true)"
      tabindex="1">{{confirmButtonText}}</button>
    <button mat-raised-button *ngIf="cancelButtonVisible" class="btn-size" (click)="onConfirmClick(false)" tabindex="-1">{{cancelButtonText}}</button>
  </mat-dialog-actions>
</div>
